export const validPassword = 'Pass123!';
export const breachedPassword = 'Breached1!';
export const lockoutPassword = 'TooMany1!';
export const incorrectPassword = 'Incorrect1!';
export const reusedPassword = 'Reused1!';
